export const ExportFileNames = {
  USERS: "EYWP_Users.xlsx",
  TENANTS: "EYWP_Tenants.xlsx",
};
